<template>
  <div class="row" style="min-height: calc(100vh - 40px);">
    <div class="col-md-6">
    <md-toolbar md-elevation="0" class="md-transparent" style="background: white!important;height: 52px;">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h5>{{ $t($route.name) }} реал</h5>
        </div>
        <div class="md-toolbar-section-end">
          <!-- <input
            id="filter-input"
            class="indexinput"
            v-model="filter"
            type="search"
            :placeholder="$t('Қидирув')"
          > -->
        <button class="btn btn-primary mybtn insertbutton" @click="Href('/revision/jamlash/create')" v-if="rule.open==true">
                  <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Қўшиш") }}<sup>ins</sup>
        </button>
        <!-- <button class="btn btn-primary mybtn" type="button" @click="Data()">
          <b-icon icon="arrow-repeat"></b-icon>
        </button> -->
        <!-- <top></top> -->
        </div>
      </div>
    </md-toolbar>
    <b-container fluid>
    <b-table
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="$store.state.countindex"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      stacked="md"
      show-empty
      small
      @filtered="onFiltered"
      @row-dblclicked="Update"
      :filter-function="filterFunction"
    >
      <template #cell(sklad)="row">
        <span v-if="row.item.sklad != null">
          {{ row.item.sklad.name }}
        </span>
      </template>
      <template #cell(summa)="row">
        {{ row.item.summa | numFormat }}
      </template>
      <template #cell(real)="row">
        <span v-if="row.item.real == true">
          <b-icon icon="check2-circle"></b-icon>
        </span>
        <span v-else>
          <b-icon icon="check"></b-icon>
        </span>
      </template>
      <template #cell(actions)="row" v-if="rule.change==true">
        <router-link
          class="circul pencil"
          :to="{ path: '/revision/jamlash/update/' + row.item.id }"
        >
          <b-icon icon="pencil"></b-icon>
        </router-link>
        <a
          class="circul trash"
          href="javascript:void(0)"
          @click="Trash(row.item.id)"
        >
          <b-icon icon="trash"></b-icon>
        </a>
      </template>
    </b-table>
    <div class="bottomindex">
          <span>
            {{totalRows+' '+$t('ta listdan')+' '}}<span v-if="$store.state.countindex<totalRows">{{$store.state.countindex}}</span><span v-else>{{totalRows}}</span>{{$t('tasi')}}
          </span>
          <span v-if="totalRows > $store.state.countindex" style="padding:0 10px">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="$store.state.countindex"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </span>
      </div>
    </b-container>
    </div>
    <div class="col-md-6">
      <md-toolbar md-elevation="0" class="md-transparent" style="background: white!important;height: 52px;">
        <div class="md-toolbar-row">
          <div class="md-toolbar-section-start">
            <h5>{{ $t($route.name)+" "+$t('пробный') }}</h5>
          </div>
          <div class="md-toolbar-section-end">
            <!-- <input
              id="filter-input"
              class="indexinput"
              v-model="filter"
              type="search"
              :placeholder="$t('Қидирув')"
            > -->
          <button class="btn btn-primary mybtn insertbutton" @click="Href('/revision/create')" v-if="rule.open==true">
                    <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Қўшиш") }}<sup>ins</sup>
          </button>
          <!-- <button class="btn btn-primary mybtn" type="button" @click="Data()">
            <b-icon icon="arrow-repeat"></b-icon>
          </button> -->
          <top></top>
          </div>
        </div>
      </md-toolbar>
      <b-container fluid>
      <b-table
        :items="itemstest"
        :fields="fieldstest"
        :current-page="currentPagetest"
        :per-page="$store.state.countindex"
        :filter="filtertest"
        :filter-included-fields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        stacked="md"
        show-empty
        small
        @filtered="onFiltered"
        @row-dblclicked="Update"
        :filter-function="filterFunction"
      >
        <template #cell(sklad)="row">
          <span v-if="row.item.sklad != null">
            {{ row.item.sklad.name }}
          </span>
        </template>
        <template #cell(summa)="row">
          {{ row.item.summa | numFormat }}
        </template>
        <template #cell(actions)="row" v-if="rule.change==true">
          <router-link
            class="circul pencil"
            :to="{ path: '/revision/update/' + row.item.id }"
          >
            <b-icon icon="pencil"></b-icon>
          </router-link>
          <a
            class="circul trash"
            href="javascript:void(0)"
            @click="Trash(row.item.id)"
          >
            <b-icon icon="trash"></b-icon>
          </a>
        </template>
      </b-table>
      <div class="bottomindex">
            <span>
              {{totalRowstest+' '+$t('ta listdan')+' '}}<span v-if="$store.state.countindex<totalRowstest">{{$store.state.countindex}}</span><span v-else>{{totalRowstest}}</span>{{$t('tasi')}}
            </span>
            <span v-if="totalRowstest > $store.state.countindex" style="padding:0 10px">
              <b-pagination
                v-model="currentPagetest"
                :total-rows="totalRowstest"
                :per-page="$store.state.countindex"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </span>
        </div>
      </b-container>
      </div>
  </div>
</template>
<script>
import Top from "../Layout/Top.vue";
import filterFunction from "../../utils/filterFunction";
import { print } from "../../components/mixins/print.js";
export default {
  components: {Top},
  mixins: [print],
  data() {
    return {
      items: [],
      itemstest:[],
      errors: "",
      fields: [
      {
          key: "id",
          label: "ID",
          sortable: true,
          class: "text-center column1"
        },
        {
          key: "sklad",
          label: "Cклад",
          sortable: true,
          class: "text-center column3"
        },
        {
          key: "created_at",
          label: this.$t("Вақт"),
          sortable: true,
          formatter: (value, key, item) => {
            return this.Date(value);
          },
          sortByFormatted: true,
          filterByFormatted: true,
          class: "text-center column3"
        },
        {
          key: "total_real_count",
          label: "Сони",
          sortable: true,
          class: "text-center column2"
        },
        // {
        //   key: "count_all",
        //   label: "Қолдиқ",
        //   sortable: true,
        //   class: "text-center column3"
        // },
        // {
        //   key: "total_difference",
        //   label: "Фарқ",
        //   sortable: true,
        //   class: "text-center column3"
        // },
        // {
        //   key: "summa",
        //   label: "Сумма",
        //   sortable: true,
        //   class: "text-center column3"
        // },
        {
          key: "real",
          label: "Статус",
          sortable: true,
          class: "text-center column3"
        },
        {
          key: "user_id",
          label: this.$t("Ходим"),
          sortable: true,
          class: "text-center column2-5",
          formatter: (value, key, item) => {
            if(item.user!=null){
              return item.user.first_name;
            }else{
              return "";
            }
          },
          sortByFormatted: true,
          filterByFormatted: true,
        },
        { key: "actions", label: "", class: "column2" }
      ],
      fieldstest: [
      {
          key: "id",
          label: "ID",
          sortable: true,
          class: "text-center column1-5"
        },
        {
          key: "sklad",
          label: "Cклад",
          sortable: true,
          class: "text-center column3"
        },
        {
          key: "created_at",
          label: this.$t("Вақт"),
          sortable: true,
          formatter: (value, key, item) => {
            return this.Date(value);
          },
          sortByFormatted: true,
          filterByFormatted: true,
          class: "text-center column4"
        },
        {
          key: "total_real_count",
          label: "Сони",
          sortable: true,
          class: "text-center column3"
        },
        // {
        //   key: "count_all",
        //   label: "Қолдиқ",
        //   sortable: true,
        //   class: "text-center column3"
        // },
        // {
        //   key: "total_difference",
        //   label: "Фарқ",
        //   sortable: true,
        //   class: "text-center column3"
        // },
        // {
        //   key: "summa",
        //   label: "Сумма",
        //   sortable: true,
        //   class: "text-center column3"
        // },
        // {
        //   key: "real",
        //   label: "Статус",
        //   sortable: true,
        //   class: "text-center column3"
        // },
        {
          key: "user_id",
          label: this.$t("Ходим"),
          sortable: true,
          class: "text-center column2-5",
          formatter: (value, key, item) => {
            if(item.user!=null){
              return item.user.first_name;
            }else{
              return "";
            }
          },
          sortByFormatted: true,
          filterByFormatted: true,
        },
        { key: "actions", label: "", class: "column2" }
      ],
      totalRows: 1,
      totalRowstest:1,
      currentPage: 1,
      currentPagetest: 1,
      perPage: 15,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filtertest: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {
    this.Data();
    this.Datatest();
    // this.Interval();
  },
  methods: {
    filterFunction,
    Update(record, index) {
      if(this.rule.open==true){
      this.$router.push({ path: '/revision/update/' + record.id});
      }
    },
    Data(type) {
      let self = this;
      axios({
        method: "get",
        url: "api/v1/revision/type/real",
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(function(response) {
          self.items = response.data;
          self.totalRows = self.items.length;
        })
        .catch(function(error) {
          self.errors = error.message;
        });
    },
    Datatest() {
      let self = this;
      axios({
        method: "get",
        url: "api/v1/revision/type/test"
      })
        .then(function(response) {
          self.itemstest = response.data;
          self.totalRowstest = self.itemstest.length;
        })
        .catch(function(error) {
          self.errors = error.message;
        });
    },
    Interval() {
      window.setInterval(() => {
        this.Data();
      }, 60000);
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredtest(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowstest = filteredItems.length;
      this.currentPagetest = 1;
    },
    Trash(id) {
      let self=this;
      self.$prompt(self.$t("Паролни киритинг")).then(text => {
          if (text == self.update_password) {
            axios({
            method: "delete",
            url: "api/v1/revision/id/" + id
          }).then(function(response) {
            self.Data();
            self.Datatest();
          });
          } else {
            self.$store.state.errors = self.$t("Парол хато");
          }
        })
        .catch(function() {});
    }
  }
};
</script>
